// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"4fd8bed194e61fee313f","293":"2d2c896000f849aa28dd","522":"87eb29675d524fd8b46b"}[chunkId] + ".js";
};